import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { SubscribeService } from "src/app/frontend/service/subscribeService.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboarddemo.scss'],
})

export class DashboardDemoComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    isOpen = false;
    isOpen2 = false;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    chart1: any;
    chartOptions1: any;
    academyChartData: any;
    academyChartOptions: any;
    earningChartData : any;
    earningChartOptions : any;
    monthlyChartData  : any;
    monthlyChartOptions  : any;
    dualAxisChartData   : any;
    dualAxisChartOptions   : any;
    totalRecords: any;
    wallletRedemptionCount: any;
    academyRedemptionCount: any;
    usertotalRecords = 0;
    chart2: any;
    chartOptions2: any;
    userDeletelist: any;
    userKyclist: any;
    academyKyclist: any;
    proplayercount: any;
    coachescount = 0;
    //downloadAppCount: any;
    pendingPassportVerificationCount: any;
    totalTournamentDeletedRequestRecords: any;
    matricsSummaryData: any;
    statisticsData: any;
    pendingApprovalsData: any;
    subscribedUsersData: any;
    earningBreakdownData: any;
    academyDistributionData: any;
    newRegistrationTrendData: any;
    appDownloadsData: any;
    periodOption: any[];
    tournamentsOverviewData: any;

    constructor(private router: Router, private subscribeservice: SubscribeService, private dashboardService: DashboardService, private renderer: Renderer2) {}

    ngOnInit() {
      this.periodOption = [
        { label: 'Today', value: 'today' },
        { label: 'This Month', value: 'thismonth' },
        { label: 'This Year', value: 'thisyear' }
      ];        
      this.renderer.addClass(document.body, 'admin-header-normal');
      this.chart1 = {
          labels: ['8Sun', '9Mon', '10Thu', '11Wed', '12Fri', '13Sat', '14Sun'],
          datasets: [
              {
                  label: 'Revenue',
                  data: [12, 19, 3, 5, 2, 3, 9],
                  borderColor: [
                      '#FFA928',
                  ],
                  borderWidth: 4,
                  fill: true,
                  backgroundColor: [
                      'rgba(255, 169, 40, .2)'
                  ],
                  tension: .4
              }
          ]
      };

      this.chartOptions1 = {
          plugins: {
              legend: {
                  display: false,
              }
          },
          maintainAspectRatio: false,
          hover: {
              mode: 'index'
          },
          scales: {
              x: {
                  display: false,
              },
              y: {
                  display: false,
              }
          }
      };

      this.chart2 = {
          labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          datasets: [
              {
                  label: 'Registrations',
                  data: [12, 19, 3, 5, 2, 3, 9],
                  borderColor: [
                      '#1FA931',
                  ],
                  borderWidth: 2.2,
                  fill: false,
                  backgroundColor: [
                      '#1FA931',
                  ],
                  tension: .4
              }
          ]
      };

      this.chartOptions2 = {
          plugins: {
              legend: {
                  display: false,
              }
          },
          maintainAspectRatio: false,
          hover: {
              mode: 'index'
          },
          scales: {
              x: {
                  display: true,
                  grid: {
                        color: '#F0F0F0',
                      borderDash: [5, 10],
                  },
                  ticks: {
                      color: '#6B7280'
                  }
              },
              y: {
                  display: true,
                  grid: {
                      color: '#F0F0F0',
                      borderDash: [5, 10],
                  },
                  ticks: {
                      color: '#6B7280',
                      min: 0,
                      stepSize: 5,
                  }
              }
          }
      };

      this.academyChartOptions = {
        maintainAspectRatio: false,
        cutout: '65%',            // donut thickness

        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true, // 👈 circular legend dots
              pointStyle: 'circle',
              boxWidth: 10,
              boxHeight: 10,
              padding: 20,
              color: '#2D2D2D',
              font: {
                size: 14
              }
            }
          }
        }
      };

      this.earningChartOptions = {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false               // 👈 hide legend
          },
          tooltip: {
            enabled: true
          }
        },
        scales: {
          x: {
            grid: {
              display: false             // 👈 no vertical grid
            },
            ticks: {
              color: '#6B7280'
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 350,
              color: '#6B7280'
            },
            grid: {
              borderDash: [4, 4]          // 👈 dotted horizontal grid
            }
          }
        }
      };

      this.monthlyChartData = {
        labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
        datasets: [
          {
            label: 'Play Store',
            data: [3800, 4200, 3900, 4400, 4600, 4350, 4550],
            backgroundColor: '#3B82F6',   // blue
            borderRadius: 8,
            barThickness: 28
          },
          {
            label: 'App Store',
            data: [2400, 2700, 2900, 3100, 3000, 3250, 3150],
            backgroundColor: '#8B5CF6',   // purple
            borderRadius: 8,
            barThickness: 28
          }
        ]
      };

      this.monthlyChartOptions = {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              padding: 10,
              color: '#374151',
              font: {
                size: 13
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: '#6B7280'
            }
          },
          y: {
            beginAtZero: true,
            max: 6000,
            ticks: {
              stepSize: 1500,
              color: '#6B7280'
            },
            grid: {
              borderDash: [4, 4]
            }
          }
        }
      };

      // this.dualAxisChartData = {
      //   labels: ['3 Months', '6 Months', '12 Months'],
      //   datasets: [
      //     {
      //       label: 'Subscribers',
      //       data: [4500, 6200, 9000],
      //       backgroundColor: '#25A92D',
      //       borderRadius: 8,
      //       barThickness: 110,
      //       yAxisID: 'y'          // 👈 left axis
      //     },
      //     {
      //       label: 'Revenue (₹K)',
      //       data: [280, 520, 900],
      //       backgroundColor: '#D7E21B',
      //       borderRadius: 8,
      //       barThickness: 110,
      //       yAxisID: 'y1'         // 👈 right axis
      //     }
      //   ]
      // };

      this.dualAxisChartOptions = {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'rectRounded',
              padding: 20,
              color: '#374151',
              font: {
                size: 13
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: '#6B7280'
            }
          },
          y: {
            beginAtZero: true,
            max: 10000,
            ticks: {
              stepSize: 2500,
              color: '#6B7280'
            },
            grid: {
              borderDash: [4, 4]
            }
          },
          y1: {
            beginAtZero: true,
            max: 1200,
            position: 'right',
            ticks: {
              stepSize: 300,
              color: '#6B7280'
            },
            grid: {
              drawOnChartArea: false   // 👈 avoid double grid lines
            }
          }
        }
      };

      this.loadMetricsSummary();
      this.loadStatistics('today');
      this.pendingApprovals();
      this.loadEarningBreakdownData('today');
      this.loadAcademyDistributionData('today');
      this.loadNewRegistrationTrendData('today');
      this.loadAppDownloadsData('today');
      this.loadSubscribedUsersData();

      this.loadTournamentsOverview();
    }

    isEarningChartDataEmpty(): boolean {
      if (!this.earningChartData || !this.earningChartData.labels || !this.earningChartData.datasets || !this.earningChartData.datasets[0]) {
        return true;
      }
      const labels = this.earningChartData.labels;
      const data = this.earningChartData.datasets[0].data;
      const categories = ['Tournament', 'Contest', 'Court Booking', 'FAP', 'Others'];
      let allZero = true;
      categories.forEach((cat) => {
        const idx = labels.findIndex((l: string) => l.toLowerCase() === cat.toLowerCase());
        if (idx !== -1 && data[idx] && Number(data[idx]) > 0) {
          allZero = false;
        }
      });
      return allZero;
    }

    isSubscribedUsersDataEmpty(): boolean {
      if (!this.dualAxisChartData || !this.dualAxisChartData.labels || !this.dualAxisChartData.datasets || !this.dualAxisChartData.datasets[0] || !this.dualAxisChartData.datasets[1]) {
        return true;
      }
      const labels = this.dualAxisChartData.labels;
      const subscribersData = this.dualAxisChartData.datasets[0].data;
      const revenueData = this.dualAxisChartData.datasets[1].data;
      let allZero = true;
      for (let i = 0; i < labels.length; i++) {
        if ((subscribersData[i] && Number(subscribersData[i]) > 0) || (revenueData[i] && Number(revenueData[i]) > 0)) {
          allZero = false;
          break;
        }
      }
      return allZero;
    }

    isAcademyChartDataEmpty(): boolean {
      if (!this.academyChartData || !this.academyChartData.labels || !this.academyChartData.datasets || !this.academyChartData.datasets[0]) {
        return true;
      }
      const labels = this.academyChartData.labels;
      const data = this.academyChartData.datasets[0].data;
      const categories = ['Premium Academies', 'Standard Academies'];
      let allZero = true;
      categories.forEach((cat) => {
        const idx = labels.findIndex((l: string) => l.toLowerCase() === cat.toLowerCase());
        if (idx !== -1 && data[idx] && Number(data[idx]) > 0) {
          allZero = false;
        }
      });
      return allZero;
    }

    formatAmount(value: number): string {
      if (value === null || value === undefined) return '';
      if (value >= 10000000) { 
        return (value / 10000000).toFixed(2) + ' Cr';
      } else if (value >= 100000) { 
        return (value / 100000).toFixed(2) + ' L';
      } else if (value >= 1000) { 
        return (value / 1000).toFixed(2) + ' K';
      } else {
        return value.toString();
      }
    }

    formatNumberWithComma(value: number | string): string {
      if (value === null || value === undefined) return '';
      return Number(value).toLocaleString('en-IN');
    }

    changeStatisticsPeriod(val: any) {
      this.loadStatistics(val);
    }

    changeEarningPeriod(val: any) {
      this.loadEarningBreakdownData(val);
    }
    changeAcademyDistributionPeriod(val: any) {
      this.loadAcademyDistributionData(val);
    }

    changeNewRegistrationTrendPeriod(val: any) {
      this.loadNewRegistrationTrendData(val);
    }

    changeAppDownloadsPeriod(val: any) {
      this.loadAppDownloadsData(val);
    }

    loadMetricsSummary() {
      this.dashboardService.getMetricsSummary().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.matricsSummaryData = data?.data;
      }, err => {

      });
    }

    loadStatistics(period) {
      this.dashboardService.getStatistics(period).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.statisticsData = data?.data;
      }, err => {

      });
    }

    pendingApprovals() {
      this.dashboardService.getpendingApprovals().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.pendingApprovalsData = data?.data;
      }, err => {

      });
    }

    loadTournamentsOverview() {
      this.dashboardService.getTournamentsOverview().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.tournamentsOverviewData = data?.data;
      }, err => {

      });
    }

    loadEarningBreakdownData(period) {
        this.dashboardService.getEarningBreakdownData(period).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.earningBreakdownData = data?.data;
          let breakdownArr: { label: string, value: number }[] = [];
          if (Array.isArray(this.earningBreakdownData?.breakdown)) {
            breakdownArr = this.earningBreakdownData.breakdown;
          } else if (this.earningBreakdownData && typeof this.earningBreakdownData === 'object') {
            breakdownArr = Object.keys(this.earningBreakdownData).map(key => ({ label: key, value: this.earningBreakdownData[key] }));
          }
          if (breakdownArr.length > 0) {
            this.earningChartData = {
              labels: breakdownArr.map(item => item.label),
              datasets: [
                {
                  label: '',
                  data: breakdownArr.map(item => item.value),
                  backgroundColor: '#28A745',
                  borderRadius: 8,
                  barThickness: 50
                }
              ]
            };
          }
        }, err => {
        });
    }

    loadAcademyDistributionData(period) {
      this.dashboardService.getAcademyDistributionData(period).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.academyDistributionData = data?.data;
          let distArr: { label: string, value: number }[] = [];
          if (Array.isArray(this.academyDistributionData)) {
            distArr = this.academyDistributionData;
          } else if (this.academyDistributionData && typeof this.academyDistributionData === 'object') {
            distArr = Object.keys(this.academyDistributionData).map(key => ({ label: key, value: this.academyDistributionData[key] }));
          }
          if (distArr.length > 0) {
            this.academyChartData = {
              labels: distArr.map(item => item.label),
              datasets: [
                {
                  data: distArr.map(item => item.value),
                  backgroundColor: ['#25A92D', '#D7E21B'],
                  hoverBackgroundColor: ['#25A92D', '#D7E21B'],
                  borderColor: '#ffffff',
                  borderWidth: 6,
                  borderRadius: 6
                }
              ]
            };
          }
      }, err => {
      });
    }

    loadNewRegistrationTrendData(period) {
      this.dashboardService.getNewRegistrationTrendData(period).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.newRegistrationTrendData = data?.data;
      }, err => {

      });
    }

    loadAppDownloadsData(period) {
      this.dashboardService.getAppDownloadsData(period).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.appDownloadsData = data?.data;
      }, err => {

      });
    }

    loadSubscribedUsersData() {
      this.dashboardService.getSubscribedUsersData().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.subscribedUsersData = data?.data;
          let breakdownArr = Array.isArray(this.subscribedUsersData?.breakdown) ? this.subscribedUsersData.breakdown : [];
          if (breakdownArr.length > 0) {
            this.dualAxisChartData = {
              labels: breakdownArr.map(item => item.plan || item.label || ''),
              datasets: [
                {
                  label: 'Subscribers',
                  data: breakdownArr.map(item => item.subscribers),
                  backgroundColor: '#25A92D',
                  borderRadius: 8,
                  barThickness: 110,
                  yAxisID: 'y'
                },
                {
                  label: 'Revenue (₹K)',
                  data: breakdownArr.map(item => item.revenue),
                  backgroundColor: '#D7E21B',
                  borderRadius: 8,
                  barThickness: 110,
                  yAxisID: 'y1'
                }
              ]
            };
          }
      }, err => {
      });
    }
    tennisTournaments(filterName: string) {
        this.router.navigate(['/manage/academylist'], { queryParams: { redirect: filterName } });
    }
    pickleBallTournaments(filterName: string) {
        this.router.navigate(['/manage/pickleball-academylist'], { queryParams: { redirect: filterName } });
    }
    padelTournaments(filterName: string) {
        this.router.navigate(['/manage/padel-academylist'], { queryParams: { redirect: filterName } });
    }
    onUserLink(roleName: string) {
        this.router.navigate(['/manage/customer/user'], { queryParams: { filterByStatus: false, filterByRoleName: roleName } });
    }
    onUserVideos() {
        this.router.navigate(['/manage/customer/userlist']);
    }

    onWalletRedemption() {
        let query = "&filterByStatus=Pending"
        this.subscribeservice.pendingReqData(query);
        this.router.navigate(['/manage/report/wallet/redemption']);
    }
    
    onDeleteRequest() {
        this.router.navigate(['/manage/report/user/deleterequest']);
    }
    onUserKycList() {
        let query = "&filterByPending=true"
        this.subscribeservice.pendingReqData(query);
        this.router.navigate(['/manage/report/user/kyc-list']);
    }

    onPassportVerificationPageNavigation() {
        this.router.navigate(['/manage/customer/user'], { queryParams: { filterByPendingPassportVerification: false } });
    }

    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'admin-header-normal');
      this.destroy$.next();
      this.destroy$.complete();
    }
}
